var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 124,
    viewBox: "0 0 142 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8771 57.5163C23.2071 68.752 28.3486 81.8183 38.6216 87.8201C54.133 96.8909 52.8327 110.856 83.1084 116.908C87.5241 117.814 92.0253 118.238 96.5328 118.173C98.7381 118.136 100.939 117.957 103.121 117.638C122.364 114.832 135.312 101.481 140.064 85.3629C146.315 64.167 133.833 50.2908 125.558 41.9309C117.282 33.5709 111.215 7.51768 81.5004 1.32266C76.9672 0.358444 72.3378 -0.0812357 67.7038 0.0123155C57.1305 0.272402 45.5994 3.73775 37.6291 10.9706C37.0286 11.5156 36.4479 12.0779 35.8921 12.66C24.7778 24.022 20.0656 42.1934 21.8771 57.5163Z",
    fill: "#76CCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M21.8771 57.5163C23.2071 68.752 28.3486 81.8183 38.6216 87.8201C54.133 96.8909 52.8327 110.856 83.1084 116.908C87.5241 117.814 92.0253 118.238 96.5328 118.173C98.7381 118.136 100.939 117.957 103.121 117.638C122.364 114.832 135.312 101.481 140.064 85.3629C146.315 64.167 133.833 50.2908 125.558 41.9309C117.282 33.5709 111.215 7.51768 81.5004 1.32266C76.9672 0.358444 72.3378 -0.0812357 67.7038 0.0123155C57.1305 0.272402 45.5994 3.73775 37.6291 10.9706C37.0286 11.5156 36.4479 12.0779 35.8921 12.66C24.7778 24.022 20.0656 42.1934 21.8771 57.5163Z",
    fill: "#252730"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1881_25917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8202 27H10.9998V90.3633H49.8202V27Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5977 74.1129C47.6105 65.6674 42.4347 57.1799 34.0372 55.1556C25.6397 53.1313 17.2004 58.3367 15.1876 66.7822C13.1748 75.2278 18.3506 83.7153 26.7481 85.7396C35.1457 87.7639 43.5849 82.5585 45.5977 74.1129Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4099 81.8383C36.6649 81.8383 41.7355 76.7387 41.7355 70.448C41.7355 64.1573 36.6649 59.0576 30.4099 59.0576C24.155 59.0576 19.0844 64.1573 19.0844 70.448C19.0844 76.7387 24.155 81.8383 30.4099 81.8383Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 50.7835C28.6477 50.7835 32.6181 46.7904 32.6181 41.8647C32.6181 36.9389 28.6477 32.9458 23.75 32.9458C18.8522 32.9458 14.8818 36.9389 14.8818 41.8647C14.8818 46.7904 18.8522 50.7835 23.75 50.7835Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 47.0223C26.5825 47.0223 28.8786 44.7131 28.8786 41.8644C28.8786 39.0158 26.5825 36.7065 23.75 36.7065C20.9176 36.7065 18.6215 39.0158 18.6215 41.8644C18.6215 44.7131 20.9176 47.0223 23.75 47.0223Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6278 41.7755C46.662 39.8217 46.7361 36.5793 44.7933 34.5334C42.8506 32.4876 39.6266 32.4131 37.5924 34.367C35.5582 36.3208 35.4841 39.5633 37.4269 41.6091C39.3697 43.6549 42.5936 43.7294 44.6278 41.7755Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1454 40.2276C44.3295 39.0971 44.3782 37.2153 43.2542 36.0244C42.1302 34.8336 40.259 34.7846 39.0749 35.915C37.8908 37.0455 37.8421 38.9273 38.9661 40.1182C40.0902 41.3091 41.9613 41.3581 43.1454 40.2276Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 90.3789H140.82V27.0156L102 27.0156V90.3789Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.046 85.7436C133.441 83.7106 138.608 75.2181 136.587 66.7752C134.565 58.3323 126.121 53.136 117.726 55.169C109.331 57.202 104.164 65.6944 106.186 74.1374C108.207 82.5803 116.651 87.7766 125.046 85.7436Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.391 81.8388C127.646 81.8388 132.717 76.7392 132.717 70.4485C132.717 64.1577 127.646 59.0581 121.391 59.0581C115.136 59.0581 110.065 64.1577 110.065 70.4485C110.065 76.7392 115.136 81.8388 121.391 81.8388Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.051 50.7835C132.949 50.7835 136.919 46.7904 136.919 41.8647C136.919 36.9389 132.949 32.9458 128.051 32.9458C123.153 32.9458 119.183 36.9389 119.183 41.8647C119.183 46.7904 123.153 50.7835 128.051 50.7835Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.051 47.0223C130.883 47.0223 133.18 44.7131 133.18 41.8644C133.18 39.0158 130.883 36.7065 128.051 36.7065C125.219 36.7065 122.922 39.0158 122.922 41.8644C122.922 44.7131 125.219 47.0223 128.051 47.0223Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.689 42.2077C115.97 40.5531 116.486 37.3517 114.841 35.0572C113.196 32.7628 110.013 32.244 107.731 33.8986C105.45 35.5532 104.934 38.7546 106.579 41.049C108.224 43.3435 111.408 43.8623 113.689 42.2077Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.447 40.4633C113.768 39.4993 114.062 37.6404 113.104 36.3113C112.145 34.9821 110.297 34.6861 108.976 35.6501C107.654 36.6141 107.36 38.473 108.318 39.8021C109.277 41.1312 111.125 41.4273 112.447 40.4633Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.849 90.3632L20.1223 90.2915L37.3956 90.2557L71.9422 90.1841L106.453 90.2557L123.727 90.2915L141 90.3632L123.727 90.4706L106.453 90.5065L71.9422 90.5423L37.3956 90.5065L20.1223 90.4706L2.849 90.3632Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.982 87.3188H97.9056V88.1427H108.982V87.3188Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.056 61.8877L108.127 65.7561L108.483 89.7547V90.5785L108.661 101.36H109.302L109.445 90.5785L109.481 89.7547L109.837 65.7561L109.908 61.8877H108.056Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.908 61.8877H108.056L108.127 65.7561H109.837L109.908 61.8877Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9796 61.8877L97.0508 65.7561L97.6207 101.36H98.2261L98.4042 90.5785V89.7547L98.796 65.7561L98.8316 61.8877H96.9796Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9796 61.8877L97.0508 65.7561H98.796L98.8316 61.8877H96.9796Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.502 87.3188H103.64V88.1427H114.502V87.3188Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.576 61.8877L113.647 65.7561L114.004 89.7547L114.039 90.5785L114.182 101.36H114.823L115.357 65.7561L115.428 61.8877H113.576Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.428 61.8877H113.576L113.647 65.7561H115.357L115.428 61.8877Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.714 61.8877L102.785 65.7561L103.141 89.7547L103.177 90.5785L103.319 101.36H103.96L104.103 90.5785L104.138 89.7547L104.494 65.7561L104.566 61.8877H102.714Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.566 61.8877H102.714L102.785 65.7561H104.494L104.566 61.8877Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.176 60.0967H96.0536V64.2516H116.176V60.0967Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M111.974 60.0967H96.0536V64.2516H111.974V60.0967Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2644 32.2795L38.3396 32.3267L38.4441 34.4014L39.3689 34.3543L39.2644 32.2795Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1347 37.8176C54.2771 40.3249 47.6527 42.6889 39.3544 43.1187C31.0561 43.5486 24.2536 41.8651 24.1468 39.322C24.0043 36.8147 30.5931 33.985 38.8914 33.5552C47.1541 33.1611 53.9922 35.3103 54.1347 37.8176Z",
    fill: "#97223B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.1347 37.8176C54.2771 40.3249 47.6527 42.6889 39.3544 43.1187C31.0561 43.5486 24.2536 41.8651 24.1468 39.322C24.0043 36.8147 30.5931 33.985 38.8914 33.5552C47.1541 33.1611 53.9922 35.3103 54.1347 37.8176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0546 42.3922C54.254 39.8879 47.7083 37.3174 39.4343 36.6508C31.1602 35.9842 24.2911 37.474 24.0916 39.9783C23.8922 42.4826 30.4379 45.0531 38.7119 45.7197C46.986 46.3863 53.8551 44.8965 54.0546 42.3922Z",
    fill: "#D53B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7462 103.187H38.4285V42.7605L39.1052 42.5098L39.7462 42.7605V103.187Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5297 104.834H37.6449L38.0723 102.721H40.1023L40.5297 104.834Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7434 59.6312C40.7434 60.5625 39.9955 61.3147 39.0695 61.3147C38.1435 61.3147 37.3956 60.5625 37.3956 59.6312C37.3956 58.6999 38.1435 57.9478 39.0695 57.9478C39.9955 57.9478 40.7434 58.6999 40.7434 59.6312Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7878 99.0319L23.7194 98.2081L38.4996 78.1138L39.5681 78.9376L24.7878 99.0319Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1796 100.142H22.2948L23.6126 98.0288H25.607L25.1796 100.142Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3867 99.0319L54.4551 98.2081L39.6749 78.1138L38.6064 78.9376L53.3867 99.0319Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9949 100.142H55.8797L54.5619 98.0288H52.5675L52.9949 100.142Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9969 78.1853L90.6764 57.8045C90.6764 57.8045 94.7721 54.4375 106.205 54.4375C117.637 54.4375 121.092 57.2672 121.092 57.2672L121.412 78.1495H90.9969V78.1853Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M90.9969 78.1853L90.6764 57.8045C90.6764 57.8045 94.7721 54.4375 106.205 54.4375C117.637 54.4375 121.092 57.2672 121.092 57.2672L121.412 78.1495H90.9969V78.1853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.205 81.8388C114.604 81.8388 121.412 80.203 121.412 78.1852C121.412 76.1675 114.604 74.5317 106.205 74.5317C97.8056 74.5317 90.9969 76.1675 90.9969 78.1852C90.9969 80.203 97.8056 81.8388 106.205 81.8388Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3915 58.8074L89.9998 56.515C90.2491 56.4075 95.1996 53.7569 106.169 53.3271C116.996 52.8973 121.733 55.727 121.982 55.8702L121.733 58.2343C121.697 58.1984 116.391 55.1539 106.276 55.5479C95.8406 55.9777 90.4271 58.7716 90.3915 58.8074Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9969 78.3644L90.5339 75.8212C90.7832 75.7138 95.1995 73.3139 106.169 72.9199C116.996 72.4901 121.412 75.4989 121.661 75.6421L121.448 78.2211C121.412 78.1853 116.39 74.7825 106.276 75.1765C95.8406 75.5347 91.0682 78.3285 90.9969 78.3644Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5858 56.0132H96.9803V74.7464H97.5858V56.0132Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.12 56.1925C98.12 56.6581 97.7638 57.0163 97.3008 57.0163C96.8378 57.0163 96.4817 56.6581 96.4817 56.1925C96.4817 55.7268 96.8378 55.3687 97.3008 55.3687C97.7282 55.3687 98.12 55.7268 98.12 56.1925Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.12 74.317C98.12 74.7826 97.7638 75.1408 97.3008 75.1408C96.8378 75.1408 96.4817 74.7826 96.4817 74.317C96.4817 73.8514 96.8378 73.4932 97.3008 73.4932C97.7282 73.4932 98.12 73.8872 98.12 74.317Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.536 55.3687H114.93V74.1018H115.536V55.3687Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.034 55.9059C116.034 56.3715 115.678 56.7297 115.215 56.7297C114.752 56.7297 114.396 56.3715 114.396 55.9059C114.396 55.4402 114.752 55.082 115.215 55.082C115.678 55.082 116.034 55.476 116.034 55.9059Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.034 74.066C116.034 74.5317 115.678 74.8898 115.215 74.8898C114.752 74.8898 114.396 74.5317 114.396 74.066C114.396 73.6004 114.752 73.2422 115.215 73.2422C115.678 73.2422 116.034 73.6004 116.034 74.066Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.774 70.8782C119.774 71.8811 118.955 72.7049 117.958 72.7049C116.96 72.7049 116.141 71.8811 116.141 70.8782C116.141 69.8752 116.96 69.0514 117.958 69.0514C118.955 69.0156 119.774 69.8394 119.774 70.8782Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 70.8779H117.21V104.01H118.706V70.8779Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.56 105.801H116.355L116.854 103.473H119.097L119.56 105.801Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6982 70.8782C95.6982 71.8811 94.879 72.7049 93.8818 72.7049C92.8846 72.7049 92.0654 71.8811 92.0654 70.8782C92.0654 69.8752 92.8846 69.0514 93.8818 69.0514C94.879 69.0156 95.6982 69.8394 95.6982 70.8782Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6297 70.8779H93.1339V104.01H94.6297V70.8779Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4845 105.801H92.2792L92.7778 103.473H95.0215L95.4845 105.801Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0117 57.4106L46.798 43.6203C46.798 43.6203 49.5759 41.3638 57.3044 41.3638C65.0329 41.3638 67.3835 43.298 67.3835 43.298L67.5972 57.4464H47.0117V57.4106Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6327 57.4105C67.6327 58.7716 63.0384 59.8819 57.34 59.8819C51.6416 59.8819 47.0472 58.7716 47.0472 57.4105C47.0472 56.0493 51.6416 54.939 57.34 54.939C63.0028 54.939 67.6327 56.0493 67.6327 57.4105Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6199 44.3008L46.335 42.7606C46.4774 42.6889 49.8609 40.898 57.2688 40.6115C64.6055 40.3249 67.8108 42.2233 67.9533 42.3307L67.7752 43.9426C67.7396 43.9068 64.1425 41.8651 57.3044 42.1158C50.3238 42.4024 46.6555 44.3008 46.6199 44.3008Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0472 57.5538L46.7267 55.8345C46.8691 55.7629 49.8964 54.151 57.3044 53.8645C64.6411 53.5779 67.6327 55.6196 67.7752 55.6912L67.6327 57.4105C67.5971 57.3747 64.2137 55.0823 57.3756 55.3688C50.3238 55.6554 47.0828 57.518 47.0472 57.5538Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.518 41.3638H57.1262V54.0436H57.518V41.3638Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3043 42.2951C57.619 42.2951 57.8742 42.0385 57.8742 41.722C57.8742 41.4055 57.619 41.1489 57.3043 41.1489C56.9896 41.1489 56.7345 41.4055 56.7345 41.722C56.7345 42.0385 56.9896 42.2951 57.3043 42.2951Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8742 54.0438C57.8742 54.3662 57.6249 54.6169 57.3043 54.6169C56.9838 54.6169 56.7345 54.3662 56.7345 54.0438C56.7345 53.7214 56.9838 53.4707 57.3043 53.4707C57.6249 53.4707 57.8742 53.7214 57.8742 54.0438Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6828 42.7251H49.291V55.4049H49.6828V42.7251Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4691 43.4055C49.7838 43.4055 50.039 43.1489 50.039 42.8324C50.039 42.5159 49.7838 42.2593 49.4691 42.2593C49.1544 42.2593 48.8993 42.5159 48.8993 42.8324C48.8993 43.1489 49.1544 43.4055 49.4691 43.4055Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4691 55.6911C49.7838 55.6911 50.039 55.4345 50.039 55.118C50.039 54.8015 49.7838 54.5449 49.4691 54.5449C49.1544 54.5449 48.8993 54.8015 48.8993 55.118C48.8993 55.4345 49.1544 55.6911 49.4691 55.6911Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4247 42.2949H65.033V54.9747H65.4247V42.2949Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2466 43.2263C65.5613 43.2263 65.8164 42.9697 65.8164 42.6532C65.8164 42.3367 65.5613 42.0801 65.2466 42.0801C64.9319 42.0801 64.6768 42.3367 64.6768 42.6532C64.6768 42.9697 64.9319 43.2263 65.2466 43.2263Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2466 55.5119C65.5613 55.5119 65.8164 55.2553 65.8164 54.9388C65.8164 54.6223 65.5613 54.3657 65.2466 54.3657C64.9319 54.3657 64.6768 54.6223 64.6768 54.9388C64.6768 55.2553 64.9319 55.5119 65.2466 55.5119Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7841 50.7838C51.7841 51.7867 50.965 52.6105 49.9677 52.6105C48.9705 52.6105 48.1514 51.7867 48.1514 50.7838C48.1514 49.7809 48.9705 48.957 49.9677 48.957C51.0006 48.957 51.7841 49.7809 51.7841 50.7838Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7157 50.7837H49.2198V103.831H50.7157V50.7837Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6061 105.658H48.3651L48.8637 103.294H51.1075L51.6061 105.658Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4931 50.7838C66.4931 51.7867 65.6739 52.6105 64.6767 52.6105C63.6795 52.6105 62.8604 51.7867 62.8604 50.7838C62.8604 49.7809 63.6795 48.957 64.6767 48.957C65.6739 48.957 66.4931 49.7809 66.4931 50.7838Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4247 50.7837H63.9288V103.831H65.4247V50.7837Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2794 105.658H63.0385L63.5371 103.294H65.7808L66.2794 105.658Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1731 79.9763C54.1762 79.9763 54.9894 79.1584 54.9894 78.1495C54.9894 77.1406 54.1762 76.3228 53.1731 76.3228C52.1699 76.3228 51.3567 77.1406 51.3567 78.1495C51.3567 79.1584 52.1699 79.9763 53.1731 79.9763Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.921 78.1494H52.4252V103.831H53.921V78.1494Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8114 105.658H51.5704L52.069 103.294H54.3128L54.8114 105.658Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5398 54.4375L81.7364 56.6583C81.7364 56.6583 97.6563 64.9324 96.5878 79.6897C95.5194 94.447 81.3446 100.715 80.7748 100.5C80.2049 100.321 60.8303 101.861 60.8303 101.861L62.5398 54.4375Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8659 101.861C71.8809 101.861 80.8104 91.2291 80.8104 78.1135C80.8104 64.998 71.8809 54.3657 60.8659 54.3657C49.8509 54.3657 40.9215 64.998 40.9215 78.1135C40.9215 91.2291 49.8509 101.861 60.8659 101.861Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2109 101.647H63.2521C70.8737 100.142 79.172 92.3337 79.635 78.0779C80.0624 64.0011 69.9477 55.2971 62.5398 54.4375H64.1425C72.4408 55.4046 82.413 62.6042 81.95 78.1495C81.4514 93.7664 73.7229 99.9631 65.2109 101.647Z",
    fill: "#D53B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1635 78.0054V78.7935H95.8396V78.0054H82.1635Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8404 79.4748C83.4305 79.4748 83.9089 78.9937 83.9089 78.4002C83.9089 77.8068 83.4305 77.3257 82.8404 77.3257C82.2503 77.3257 81.772 77.8068 81.772 78.4002C81.772 78.9937 82.2503 79.4748 82.8404 79.4748Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8756 79.4748C96.4657 79.4748 96.944 78.9937 96.944 78.4002C96.944 77.8068 96.4657 77.3257 95.8756 77.3257C95.2855 77.3257 94.8071 77.8068 94.8071 78.4002C94.8071 78.9937 95.2855 79.4748 95.8756 79.4748Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5858 61.8243V62.6123H88.3772V61.8243H77.5858Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2461 63.2844C78.8362 63.2844 79.3145 62.8033 79.3145 62.2098C79.3145 61.6164 78.8362 61.1353 78.2461 61.1353C77.656 61.1353 77.1776 61.6164 77.1776 62.2098C77.1776 62.8033 77.656 63.2844 78.2461 63.2844Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3607 63.2844C88.9508 63.2844 89.4291 62.8033 89.4291 62.2098C89.4291 61.6164 88.9508 61.1353 88.3607 61.1353C87.7706 61.1353 87.2922 61.6164 87.2922 62.2098C87.2922 62.8033 87.7706 63.2844 88.3607 63.2844Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8081 96.8712V97.6592H85.5995V96.8712H74.8081Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4681 96.2021C76.038 96.2021 76.5366 96.6678 76.5366 97.2767C76.5366 97.8498 76.0736 98.3513 75.4681 98.3513C74.8983 98.3513 74.3997 97.8856 74.3997 97.2767C74.3997 96.6678 74.8627 96.2021 75.4681 96.2021Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6184 96.2021C86.1882 96.2021 86.6868 96.6678 86.6868 97.2767C86.6868 97.8498 86.2238 98.3513 85.6184 98.3513C85.0485 98.3513 84.5499 97.8856 84.5499 97.2767C84.5499 96.6678 85.0129 96.2021 85.6184 96.2021Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2183 78.1495C88.2183 79.1524 87.3992 79.9763 86.4019 79.9763C85.4047 79.9763 84.5856 79.1524 84.5856 78.1495C84.5856 77.1466 85.4047 76.3228 86.4019 76.3228C87.3992 76.3228 88.2183 77.1466 88.2183 78.1495Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1499 78.1494H85.6541V103.831H87.1499V78.1494Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0046 105.658H84.7637L85.2623 103.294H87.506L88.0046 105.658Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.239 33.376H105.207V35.7042H106.239V33.376Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.551 40.3608C122.551 43.1547 115.036 45.4471 105.741 45.4471C96.4453 45.4471 88.9305 43.1905 88.9305 40.3608C88.9305 37.567 96.4453 34.8089 105.741 34.8089C115.036 34.7731 122.551 37.567 122.551 40.3608Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.551 40.3608C122.551 43.1547 115.036 45.4471 105.741 45.4471C96.4453 45.4471 88.9305 43.1905 88.9305 40.3608C88.9305 37.567 96.4453 34.8089 105.741 34.8089C115.036 34.7731 122.551 37.567 122.551 40.3608Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.741 47.0231C115.025 47.0231 122.551 44.7459 122.551 41.9368C122.551 39.1278 115.025 36.8506 105.741 36.8506C96.4568 36.8506 88.9305 39.1278 88.9305 41.9368C88.9305 44.7459 96.4568 47.0231 105.741 47.0231Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.489 109.741H104.993V42.4379L105.741 42.1514L106.489 42.4379V109.741Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.344 111.568H104.138L104.601 109.24H106.845L107.344 111.568Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.741 63.1055C106.764 63.1055 107.593 62.2716 107.593 61.2429C107.593 60.2143 106.764 59.3804 105.741 59.3804C104.718 59.3804 103.889 60.2143 103.889 61.2429C103.889 62.2716 104.718 63.1055 105.741 63.1055Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.122 81.8215L88.5555 104.205L89.7555 105.103L106.322 82.7197L105.122 81.8215Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1771 106.338H86.9362L88.3964 104.01H90.6401L90.1771 106.338Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.395 81.8171L105.195 82.7153L121.761 105.099L122.961 104.201L106.395 81.8171Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.305 106.338H124.546L123.086 104.01H120.842L121.305 106.338Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9998 80.1826H16.9998V113.667H63.9998V80.1826Z",
    fill: "#525460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5119 89.3271H19.4878V111.074H61.5119V89.3271Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6522 89.9189H20.3019V110.391H60.6522V89.9189Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5233 90.4194C21.5685 93.695 21.5685 96.9251 21.5685 100.201C21.5685 103.476 21.5685 106.706 21.5233 109.982C21.478 106.706 21.478 103.476 21.478 100.201C21.478 96.9251 21.478 93.6495 21.5233 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8804 90.4194C22.9257 93.695 22.9257 96.9251 22.9257 100.201C22.9257 103.476 22.9257 106.706 22.8804 109.982C22.8352 106.706 22.8352 103.476 22.8352 100.201C22.8352 96.9251 22.8352 93.6495 22.8804 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2375 90.4194C24.2827 93.695 24.2827 96.9251 24.2827 100.201C24.2827 103.476 24.2827 106.706 24.2375 109.982C24.1923 106.706 24.1923 103.476 24.1923 100.201C24.1923 96.9251 24.1923 93.6495 24.2375 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5946 90.4194C25.6398 93.695 25.6398 96.9251 25.6398 100.201C25.6398 103.476 25.6398 106.706 25.5946 109.982C25.5493 106.706 25.5493 103.476 25.5493 100.201C25.5493 96.9251 25.5493 93.6495 25.5946 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9516 90.4194C26.9968 93.695 26.9968 96.9251 26.9968 100.201C26.9968 103.476 26.9968 106.706 26.9516 109.982C26.9064 106.706 26.9064 103.476 26.9064 100.201C26.9064 96.9251 26.9064 93.6495 26.9516 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3087 90.4194C28.354 93.695 28.354 96.9251 28.354 100.201C28.354 103.476 28.354 106.706 28.3087 109.982C28.2635 106.706 28.2635 103.476 28.2635 100.201C28.2635 96.9251 28.2183 93.6495 28.3087 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6658 90.4194C29.711 93.695 29.711 96.9251 29.711 100.201C29.711 103.476 29.711 106.706 29.6658 109.982C29.6206 106.706 29.6206 103.476 29.6206 100.201C29.6206 96.9251 29.5753 93.6495 29.6658 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0227 90.4194C31.068 93.695 31.068 96.9251 31.068 100.201C31.068 103.476 31.068 106.706 31.0227 109.982C30.9775 106.706 30.9775 103.476 30.9775 100.201C30.9775 96.9251 30.9323 93.6495 31.0227 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3347 90.4194C32.3799 93.695 32.3799 96.9251 32.3799 100.201C32.3799 103.476 32.3799 106.706 32.3347 109.982C32.2894 106.706 32.2894 103.476 32.2894 100.201C32.3347 96.9251 32.2894 93.6495 32.3347 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6917 90.4194C33.737 93.695 33.737 96.9251 33.737 100.201C33.737 103.476 33.737 106.706 33.6917 109.982C33.6465 106.706 33.6465 103.476 33.6465 100.201C33.6917 96.9251 33.6465 93.6495 33.6917 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0489 90.4194C35.0941 93.695 35.0941 96.9251 35.0941 100.201C35.0941 103.476 35.0941 106.706 35.0489 109.982C35.0037 106.706 35.0037 103.476 35.0037 100.201C35.0489 96.9251 35.0037 93.6495 35.0489 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.406 90.4194C36.4512 93.695 36.4512 96.9251 36.4512 100.201C36.4512 103.476 36.4512 106.706 36.406 109.982C36.3607 106.706 36.3607 103.476 36.3607 100.201C36.406 96.9251 36.3607 93.6495 36.406 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7629 90.4194C37.8081 93.695 37.8081 96.9251 37.8081 100.201C37.8081 103.476 37.8081 106.706 37.7629 109.982C37.7177 106.706 37.7177 103.476 37.7177 100.201C37.7629 96.9251 37.7177 93.6495 37.7629 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1201 90.4194C39.1653 93.695 39.1653 96.9251 39.1653 100.201C39.1653 103.476 39.1653 106.706 39.1201 109.982C39.0748 106.706 39.0748 103.476 39.0748 100.201C39.1201 96.9251 39.0748 93.6495 39.1201 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4771 90.4194C40.5224 93.695 40.5224 96.9251 40.5224 100.201C40.5224 103.476 40.5224 106.706 40.4771 109.982C40.4319 106.706 40.4319 103.476 40.4319 100.201C40.4319 96.9251 40.4319 93.6495 40.4771 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8343 90.4194C41.8795 93.695 41.8795 96.9251 41.8795 100.201C41.8795 103.476 41.8795 106.706 41.8343 109.982C41.7891 106.706 41.7891 103.476 41.7891 100.201C41.7891 96.9251 41.7891 93.6495 41.8343 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1912 90.4194C43.2365 93.6495 43.2365 96.9251 43.2365 100.201C43.2365 103.476 43.2365 106.706 43.1912 109.982C43.146 106.706 43.146 103.476 43.146 100.201C43.146 96.9251 43.146 93.6495 43.1912 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5483 90.4194C44.5935 93.6495 44.5935 96.9251 44.5935 100.201C44.5935 103.476 44.5935 106.706 44.5483 109.982C44.5031 106.706 44.5031 103.476 44.5031 100.201C44.5031 96.9251 44.5031 93.6495 44.5483 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9055 90.4194C45.9507 93.6495 45.9507 96.9251 45.9507 100.201C45.9507 103.476 45.9507 106.706 45.9055 109.982C45.8602 106.706 45.8602 103.476 45.8602 100.201C45.8602 96.9251 45.8602 93.6495 45.9055 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2625 90.4194C47.3078 93.6495 47.3078 96.9251 47.3078 100.201C47.3078 103.476 47.3078 106.706 47.2625 109.982C47.2173 106.706 47.2173 103.476 47.2173 100.201C47.2173 96.9251 47.2173 93.6495 47.2625 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6195 90.4194C48.6647 93.6495 48.6647 96.9251 48.6647 100.201C48.6647 103.476 48.6647 106.706 48.6195 109.982C48.5742 106.706 48.5742 103.476 48.5742 100.201C48.5742 96.9251 48.5742 93.6495 48.6195 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9766 90.4194C50.0219 93.6495 50.0219 96.9251 50.0219 100.201C50.0219 103.476 50.0219 106.706 49.9766 109.982C49.9314 106.706 49.9314 103.476 49.9314 100.201C49.9314 96.9251 49.9314 93.6495 49.9766 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3337 90.4194C51.3789 93.6495 51.3789 96.9251 51.3789 100.201C51.3789 103.476 51.3789 106.706 51.3337 109.982C51.2885 106.706 51.2885 103.476 51.2885 100.201C51.2885 96.9251 51.2885 93.6495 51.3337 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6909 90.4194C52.7361 93.6495 52.7361 96.9251 52.7361 100.201C52.7361 103.476 52.7361 106.706 52.6909 109.982C52.6456 106.706 52.6456 103.476 52.6456 100.201C52.6456 96.9251 52.6456 93.6495 52.6909 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0478 90.4194C54.093 93.6495 54.093 96.9251 54.093 100.201C54.093 103.476 54.093 106.706 54.0478 109.982C54.0026 106.706 54.0026 103.476 54.0026 100.201C54.0026 96.9251 54.0026 93.6495 54.0478 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.405 90.4194C55.4502 93.6495 55.4502 96.9251 55.4502 100.201C55.4502 103.476 55.4502 106.706 55.405 109.982C55.3597 106.706 55.3597 103.476 55.3597 100.201C55.3597 96.9251 55.3597 93.6495 55.405 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.762 90.4194C56.8073 93.6495 56.8073 96.9251 56.8073 100.201C56.8073 103.476 56.8073 106.706 56.762 109.982C56.7168 106.706 56.7168 103.476 56.7168 100.201C56.7168 96.9251 56.7168 93.6495 56.762 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1191 90.4194C58.1643 93.6495 58.1643 96.9251 58.1643 100.201C58.1643 103.476 58.1643 106.706 58.1191 109.982C58.0739 106.706 58.0739 103.476 58.0739 100.201C58.0739 96.9251 58.0739 93.6495 58.1191 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4761 90.4194C59.5214 93.6495 59.5214 96.9251 59.5214 100.201C59.5214 103.476 59.5214 106.706 59.4761 109.982C59.4309 106.706 59.4309 103.476 59.4309 100.201C59.4309 96.9251 59.4309 93.6495 59.4761 90.4194Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 92.0118C53.5502 92.0573 47.0363 92.0573 40.4771 92.0573C33.9179 92.0573 27.4039 92.0573 20.8447 92.0118C27.4039 91.9663 33.9179 91.9663 40.4771 91.9663C47.0363 91.9663 53.5955 91.9663 60.1094 92.0118Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 93.3765C53.5502 93.422 47.0363 93.422 40.4771 93.422C33.9179 93.422 27.4039 93.422 20.8447 93.3765C27.4039 93.3311 33.9179 93.3311 40.4771 93.3311C47.0363 93.3311 53.5955 93.3311 60.1094 93.3765Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 94.7413C53.5502 94.7868 47.0363 94.7868 40.4771 94.7868C33.9179 94.7868 27.4039 94.7868 20.8447 94.7413C27.4039 94.6958 33.9179 94.6958 40.4771 94.6958C47.0363 94.6958 53.5955 94.6958 60.1094 94.7413Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 96.106C53.5502 96.1515 47.0363 96.1515 40.4771 96.1515C33.9179 96.1515 27.4039 96.1515 20.8447 96.106C27.4039 96.0605 33.9179 96.0605 40.4771 96.0605C47.0363 96.0605 53.5955 96.0605 60.1094 96.106Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 97.4713C53.5502 97.5168 47.0363 97.5168 40.4771 97.5168C33.9179 97.5168 27.4039 97.5168 20.8447 97.4713C27.4039 97.4258 33.9179 97.4258 40.4771 97.4258C47.0363 97.4258 53.5955 97.4258 60.1094 97.4713Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 98.836C53.5502 98.8815 47.0363 98.8815 40.4771 98.8815C33.9179 98.8815 27.4039 98.8815 20.8447 98.836C27.4039 98.7905 33.9179 98.7905 40.4771 98.7905C47.0363 98.7905 53.5955 98.7905 60.1094 98.836Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 100.2C53.5502 100.246 47.0363 100.246 40.4771 100.246C33.9179 100.246 27.4039 100.246 20.8447 100.2C27.4039 100.155 33.9179 100.155 40.4771 100.155C47.0363 100.155 53.5955 100.155 60.1094 100.2Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 101.566C53.5502 101.611 47.0363 101.611 40.4771 101.611C33.9179 101.611 27.4039 101.611 20.8447 101.566C27.4039 101.52 33.9179 101.52 40.4771 101.52C47.0363 101.52 53.5955 101.475 60.1094 101.566Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 102.93C53.5502 102.975 47.0363 102.975 40.4771 102.975C33.9179 102.975 27.4039 102.975 20.8447 102.93C27.4039 102.884 33.9179 102.884 40.4771 102.884C47.0363 102.884 53.5955 102.839 60.1094 102.93Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 104.25C53.5502 104.295 47.0363 104.295 40.4771 104.295C33.9179 104.295 27.4039 104.295 20.8447 104.25C27.4039 104.204 33.9179 104.204 40.4771 104.204C47.0363 104.25 53.5955 104.204 60.1094 104.25Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 105.615C53.5502 105.66 47.0363 105.66 40.4771 105.66C33.9179 105.66 27.4039 105.66 20.8447 105.615C27.4039 105.569 33.9179 105.569 40.4771 105.569C47.0363 105.615 53.5955 105.569 60.1094 105.615Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 106.979C53.5502 107.025 47.0363 107.025 40.4771 107.025C33.9179 107.025 27.4039 107.025 20.8447 106.979C27.4039 106.934 33.9179 106.934 40.4771 106.934C47.0363 106.979 53.5955 106.934 60.1094 106.979Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 108.344C53.5502 108.39 47.0363 108.39 40.4771 108.39C33.9179 108.39 27.4039 108.39 20.8447 108.344C27.4039 108.299 33.9179 108.299 40.4771 108.299C47.0363 108.344 53.5955 108.299 60.1094 108.344Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6177 82.7764H19.4878V87.3713H39.6177V82.7764Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2625 84.7781H42.8746C42.3318 84.7781 41.8794 84.3232 41.8794 83.7772C41.8794 83.2313 42.3318 82.7764 42.8746 82.7764H47.2625C47.8053 82.7764 48.2576 83.2313 48.2576 83.7772C48.2576 84.3687 47.8053 84.7781 47.2625 84.7781Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5099 83.7772C52.5099 84.3232 52.0576 84.7781 51.5147 84.7781C50.9719 84.7781 50.5195 84.3232 50.5195 83.7772C50.5195 83.2313 50.9719 82.7764 51.5147 82.7764C52.0576 82.7764 52.5099 83.2313 52.5099 83.7772Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4954 83.7772C55.4954 84.3232 55.043 84.7781 54.5002 84.7781C53.9574 84.7781 53.505 84.3232 53.505 83.7772C53.505 83.2313 53.9574 82.7764 54.5002 82.7764C55.043 82.7764 55.4954 83.2313 55.4954 83.7772Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4357 83.7772C58.4357 84.3232 57.9833 84.7781 57.4405 84.7781C56.8977 84.7781 56.4453 84.3232 56.4453 83.7772C56.4453 83.2313 56.8977 82.7764 57.4405 82.7764C58.0286 82.7764 58.4357 83.2313 58.4357 83.7772Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4262 84.7781C60.9758 84.7781 61.4214 84.33 61.4214 83.7772C61.4214 83.2245 60.9758 82.7764 60.4262 82.7764C59.8766 82.7764 59.431 83.2245 59.431 83.7772C59.431 84.33 59.8766 84.7781 60.4262 84.7781Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4685 85.051C23.4685 85.8244 22.8352 86.4613 22.0662 86.4613C21.2972 86.4613 20.6187 85.8244 20.6187 85.051C20.6187 84.2776 21.252 83.6406 22.021 83.6406C22.79 83.6406 23.4685 84.2321 23.4685 85.051Z",
    fill: "#D53B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4444 85.0508C28.4444 85.8242 27.8111 86.4611 27.0421 86.4611C26.2731 86.4611 25.6398 85.8242 25.6398 85.0508C25.6398 84.2774 26.2731 83.6405 27.0421 83.6405C27.8111 83.595 28.4444 84.2319 28.4444 85.0508Z",
    fill: "#D53B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4656 85.0508C33.4656 85.8242 32.8323 86.4611 32.0633 86.4611C31.2943 86.4611 30.661 85.8242 30.661 85.0508C30.661 84.2774 31.2943 83.6405 32.0633 83.6405C32.8323 83.595 33.4656 84.2319 33.4656 85.0508Z",
    fill: "#D53B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4869 85.051C38.4869 85.8244 37.8536 86.4613 37.0846 86.4613C36.3156 86.4613 35.6823 85.8244 35.6823 85.051C35.6823 84.2776 36.3156 83.6406 37.0846 83.6406C37.8536 83.6406 38.4869 84.2321 38.4869 85.051Z",
    fill: "#D53B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0064 113.667H19.5328V114.85H25.0064V113.667Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4666 113.667H55.993V114.85H61.4666V113.667Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0094 79H58.0739V80.1829H62.0094V79Z",
    fill: "#76CCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1881_25917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 98,
    fill: "white",
    transform: "translate(-0.000244141 27)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.fb50566decdbacda878a63f9ea763b6a.svg";
export { ForwardRef as ReactComponent };